/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Comfort_Timeslot_Generation_During_Unusual_AbsenceInputs */



/**
* | output |
* | --- |
* | "Pre-comfort time slot generation during unusual absence" |
*
* @param {Pre_Comfort_Timeslot_Generation_During_Unusual_AbsenceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pre_comfort_timeslot_generation_during_unusual_absence = /** @type {((inputs?: Pre_Comfort_Timeslot_Generation_During_Unusual_AbsenceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Comfort_Timeslot_Generation_During_Unusual_AbsenceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-comfort time slot generation during unusual absence")
	return /** @type {LocalizedString} */ ("Génération de plage de pré-confort lors d'une absence inhabituelle")
});